class ProductRecommendationCarousel {

    constructor(section) {

        this.section = section;

        this.slider = section.querySelector(".pr-carousel-slider");

        this.track = section.querySelector(".pr-carousel-track");

        this.prev = section.querySelector(".pr-prev");

        this.next = section.querySelector(".pr-next");

        this.items = section.querySelectorAll(".pr-carousel-item");

        if (!this.slider || this.items.length === 0) return;

        this.init();

    }

    init() {

        this.updateButtons();

        this.bindEvents();

    }

    getScrollAmount() {

        const card = this.items[0];

        const gap = parseInt(
            window.getComputedStyle(this.track).gap
        ) || 24;

        return card.offsetWidth + gap;

    }

    scroll(direction) {

        this.slider.scrollBy({

            left: direction * this.getScrollAmount(),

            behavior: "smooth"

        });

    }

    updateButtons() {

        if (!this.prev || !this.next) return;

        const maxScroll =
            this.slider.scrollWidth - this.slider.clientWidth;

        this.prev.disabled = this.slider.scrollLeft <= 5;

        this.next.disabled =
            this.slider.scrollLeft >= maxScroll - 5;

    }

    bindEvents() {

        this.next?.addEventListener("click", () => {

            this.scroll(1);

        });

        this.prev?.addEventListener("click", () => {

            this.scroll(-1);

        });

        this.slider.addEventListener("scroll", () => {

            this.updateButtons();

        });

        window.addEventListener("resize", () => {

            this.updateButtons();

        });

    }

}

document.addEventListener("DOMContentLoaded", () => {

    document
        .querySelectorAll(".pr-carousel")
        .forEach(section => {

            new ProductRecommendationCarousel(section);

        });

});

document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('submit', async function (event) {

    const form = event.target.closest('.pr-add-to-cart-form');

    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('.pr-add-to-cart');
    const variantInput = form.querySelector('.pr-variant-id');

    if (!variantInput || !variantInput.value) return;

    const variantId = variantInput.value;

    /* Prevent double click */
    if (button.disabled) return;

    button.disabled = true;

    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add product to cart.'
        );
      }

      console.log('Added to cart:', data);

      /*
       * IMPORTANT:
       * Nothing redirects here.
       *
       * Your current styling stays exactly the same.
       */

      /* Update cart count if theme provides it */
      try {

        const cartResponse = await fetch(
          window.Shopify.routes.root + 'cart.js'
        );

        const cart = await cartResponse.json();

        const cartCount = document.querySelector(
          '.cart-count-bubble span, .cart-count'
        );

        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }

      } catch (error) {
        console.log('Cart count update skipped:', error);
      }

    } catch (error) {

      console.error('Add to cart failed:', error);

      alert(
        error.message ||
        'Unable to add product to cart.'
      );

    } finally {

      /*
       * Restore button to its original state.
       * No styling changes.
       */

      button.disabled = false;

    }

  });

});